type CardProps = {
  title: string;
  number: number;
  unit: string;
  unitClassName?: string;
};

const DeployCard = ({ title, number, unit, unitClassName }: CardProps) => {
  return (
    <>
      <div className="flex flex-col justify-between items-center mb-6 lg:mb-0">
        <h4 className="text-[#bebbc7] text-[9px] mini:text-[11px] mb-8 pl-2 sm:text-[13px] md:text-[14px] xl:text-[18px] max-w-[160px]">
          {title}
        </h4>
        <div className="relative w-[35px] sm:scale-125 xl:scale-150">
          <h3 className="text-[28px] text-primary3 unit">{number}</h3>
          <h2
            className={`text-stroke4 text-[20px] absolute -right-3 -bottom-2 ${unitClassName}`}
          >
            {unit}
          </h2>
        </div>
      </div>
    </>
  );
};

export default DeployCard;
